<template>
  <div class="has-background-white panier-component columns">
    <div class="column is-narrow ml-40 mr-12">
      <img v-if="panneau.extensionOpportunite.urlPhoto"
          class="image tailleImage"
          :src="panneau.extensionOpportunite.urlPhoto">
      <img v-else class="image tailleImage" src="@/assets/default-placeholder.png"/>
      <p class="has-text-weight-bold has-text-dark is-size-6">
        Panneau n°<span>{{panneau.code}}</span>
      </p>
      <p>Face :
        {{panneau.extensionOpportunite.faceSelectionne.facCode}}
      </p>
      <b-modal v-model="isComponentDetailFacesLc"
        has-modal-card
        class="modal">
        <info-window-produit :panneau ="panneau"/>
      </b-modal>
      <a class="plusInfo" @click="isComponentDetailFacesLc = !isComponentDetailFacesLc">
        Plus d'informations sur la face LC
      </a>
    </div>
    <div class="column columns">
      <div class="column columns is-paddingless is-marginless">
        <div>
          <div class="column columns is-marginless is-paddingless is-multiline">
            <div class="column p-5px is-one-fifth">
              <b-field label="Tarif Brut HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency
                  v-model="panneau.extensionOpportunite.tarifAnnuel"
                  isNumber="true"
                  :disabled="disabled"
                  tabindex="0"
                  @blur="tarifAnnuelChange"/>
              </b-field>
            </div>
            <div class="column p-5px is-2">
              <b-field label="/an / mois" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-input v-model="panneau.extensionOpportunite.tarifInformation"
                                  :disabled="disabled"/>
              </b-field>
            </div>
            <div class="column p-5px is-3">
              <b-field label="Remise" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-field>
                  <input-currency
                    v-model="panneau.extensionOpportunite.remise"
                    isNumber="true"
                    :disabled="disabled"
                    @blur="remiseChange"/>
                  <b-select
                    v-model="panneau.extensionOpportunite.typeDeRemise"
                    placeholder="0"
                    :disabled="disabled">
                    <option :value="0">%-</option>
                    <option :value="1">€</option>
                  </b-select>
                </b-field>
              </b-field>
            </div>
            <div class="column p-5px is-one-fifth">
              <b-field label="Tarif Net HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency
                  v-model="panneau.extensionOpportunite.tarifNet"
                  isNumber="true"
                  :disabled="disabled"
                  @blur="tarifNetChange">
                </input-currency>
              </b-field>
            </div>
            <div class="column p-5px is-2">
              <b-field label="Durée" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-input
                  v-model="panneau.extensionOpportunite.duree"
                  placeholder=""
                  :disabled="disabled"></b-input>
              </b-field>
            </div>
            <div class="column is-4 p-5px">
              <div class="column is-12 is-paddingless">
                <div class="control">
                  <label class="subtitle">Tarif de pose HT</label>
                  <input-currency
                    v-model="panneau.extensionOpportunite.tarifDePose"
                    isNumber="true"
                    :disabled="disabled">
                  </input-currency>
                </div>
              </div>
              <div class="column is-12 is-paddingless is-relative" ref="dateDibutFin">
                <div class="control pt-10">
                  <label class="subtitle">Taxes municipales / TLPE</label>
                  <input-currency v-model="panneau.extensionOpportunite.taxeMunicipale"
                                  :disabled="disabled">
                  </input-currency>
                </div>
                Montant TLPE pour la 1ère année
              </div>
            </div>
            <div class="column is-4 p-5px">
              <div class="column is-12 is-paddingless">
                <div class="control">
                  <label class="subtitle">Frais technique HT</label>
                  <input-currency v-model="panneau.extensionOpportunite.fraisTechnique"
                                  isNumber="true"
                                  :disabled="disabled">
                  </input-currency>
                </div>
              </div>
              <div class="column is-12 is-paddingless">
                <div class="columns">
                  <div class="column control pt-10">
                    <label class="subtitle">Date de début</label>
                    <b-datepicker
                      icon="calendar-today"
                      :readonly="false"
                      v-model="panneau.extensionOpportunite.dateDisponibilite"
                      :disabled="disabled"
                      @input="dateDebutChange"/>
                  </div>
                  <div class="column control pt-10">
                    <label class="subtitle">Date de fin</label>
                    <b-datepicker
                      icon="calendar-today"
                      :readonly="false"
                      v-model="panneau.extensionOpportunite.dateFin"
                      :disabled="disabled"
                      @input="calculTlpe"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4 p-5px">
              <div class="column is-12 py-0">
                <b-field label="Commentaire" custom-class="mb-0 label-color">
                  <b-input
                    type="textarea"
                    v-model="panneau.extensionOpportunite.commentaire"
                    :disabled="disabled"/>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-narrow mr-20">
      <div class="is-flex flex-align-center-justify-end">
        <p class="has-text-weight-bold is-size-6 has-text-black mr-12">
          {{panneau.prixTotal}} €
        </p>
        <a @click="suppressionPanneau">
          <b-icon icon="delete-forever" type="is-danger"/>
        </a>
      </div>
      <div class="mt-10 p-5px has-background-color-background">
          <span class="mb-0 label-color has-text-weight-bold">Editions</span>
          <article class="media media-align-center mt-5px">
            <div class="media-left">
              <button
                class="button"
                :disabled="disabled"
                v-bind:class="[panneau.extensionOpportunite.masquerRemiseEdition ?
                  'is-primary' : 'is-grey']"
                @click.prevent="$refs.checkBoxMasquerRemiseEdition.click()">
                <b-icon
                  icon="percent"
                  :type="panneau.extensionOpportunite.masquerRemiseEdition ?
                    'is-white' : 'is-grey'"></b-icon>
              </button>
            </div>
            <div class="media-content is-paddingless">
              <div class="content has-text-weight-semibold is-inline">
                Afficher la remise sur l’édition
              </div>
              <input
                type="checkbox"
                v-model="panneau.extensionOpportunite.masquerRemiseEdition"
                :disabled="disabled"
                id="checkbox"
                class="is-invisible is-inline"
                ref="checkBoxMasquerRemiseEdition">
            </div>
          </article>
        </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { calculTlpePanneauLcInitializer } from '@/services/panier/extensionInitializer';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import infoWindowProduit from './infoWindowProduit';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'ventes-lc',
  props: ['panneau', 'disabled'],
  components: {
    inputCurrency,
    infoWindowProduit,
  },
  data() {
    return {
      isComponentDetailFacesLc: false,
      typingTimer: null,
      doneTypingInterval: 1000,
    };
  },
  computed: {
    valeurRemise() {
      if (this.panneau.extensionOpportunite.typeDeRemise === 0) {
        return (this.panneau.extensionOpportunite.tarifAnnuel
          * this.panneau.extensionOpportunite.remise) / 100;
      }
      return this.panneau.extensionOpportunite.remise;
    },
  },
  methods: {
    ...Panier.mapMutations({
      setRemoveProduit: types.REMOVE_PRODUIT_TYPE_PANNEAU,
    }),
    actionkeyUp(action) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(action, this.doneTypingInterval);
    },
    actionkeyDown() {
      clearTimeout(this.typingTimer);
    },
    tarifAnnuelChange() {
      if (this.panneau.extensionOpportunite.tarifAnnuel) {
        this.panneau.extensionOpportunite.tarifNet =
          this.panneau.extensionOpportunite.tarifAnnuel - this.valeurRemise;
      }
    },
    remiseChange() {
      if (this.panneau.extensionOpportunite.tarifAnnuel) {
        this.panneau.extensionOpportunite.tarifNet =
          this.panneau.extensionOpportunite.tarifAnnuel - this.valeurRemise;
      }
    },
    tarifNetChange() {
      if (this.panneau.extensionOpportunite.tarifAnnuel) {
        const valeurRemise = this.panneau.extensionOpportunite.tarifAnnuel
          - this.panneau.extensionOpportunite.tarifNet;
        if (this.panneau.extensionOpportunite.typeDeRemise === 0) {
          this.panneau.extensionOpportunite.remise = (valeurRemise * 100)
            / this.panneau.extensionOpportunite.tarifAnnuel;
        } else this.panneau.extensionOpportunite.remise = valeurRemise;
      }
    },
    suppressionPanneau() {
      this.setRemoveProduit(this.panneau);
    },
    dateDebutChange(date) {
      this.panneau.extensionOpportunite.date = date;
      this.calculTlpe();
    },
    async calculTlpe() {
      const loadingComponent = this.$buefy.loading.open({ container: this.$refs.dateDibutFin });
      await calculTlpePanneauLcInitializer(this.panneau);
      loadingComponent.close();
    },
  },
};
</script>

<style scoped>
  .inputFacesLc {
    padding-bottom:10px
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/ventesLc.vue